import React from "react";
import { Box, Container, Heading, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { NavbarWithCallToAction } from "../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { usePageTitle } from "../../hooks/useDocumentTitle";

// Import ModuleWhatsNew components (only for modules that have them)
import { ModuleWhatsNew as CompanyKnowledgeModuleWhatsNew } from "../companyknowledge/components/ModuleWhatsNew";
import { ModuleWhatsNew as CalendarModuleWhatsNew } from "../calendars/components/ModuleWhatsNew";
import { ModuleWhatsNew as OpportunitiesModuleWhatsNew } from "../opportunities/components/ModuleWhatsNew";
import { ModuleWhatsNew as LMModuleWhatsNew } from "../lm/components/ModuleWhatsNew";

// Import module configs
import companyKnowledgeModuleConfig from "../companyknowledge/moduleConfig";
import { calendarsModuleConfig } from "../calendars/moduleConfig";
import opportunitiesModuleConfig from "../opportunities/moduleConfig";
import lmModuleConfig from "../lm/moduleConfig";

// Map of module IDs to their WhatsNew components and configs
const whatsNewData: { [key: string]: { component: React.ComponentType<any>, config: any } } = {
    'companyknowledge': { component: CompanyKnowledgeModuleWhatsNew, config: companyKnowledgeModuleConfig },
    'calendars': { component: CalendarModuleWhatsNew, config: calendarsModuleConfig },
    'opportunities': { component: OpportunitiesModuleWhatsNew, config: opportunitiesModuleConfig },
    'lm': { component: LMModuleWhatsNew, config: lmModuleConfig },
};

const WhatsNew: React.FC = () => {
    const { moduleId } = useParams<{ moduleId: string }>();
    usePageTitle(`What's New - ${moduleId}`);

    const moduleData = moduleId ? whatsNewData[moduleId] : null;

    if (!moduleData) {
        return (
            <Box minH="100vh" display="flex" flexDirection="column">
                <NavbarWithCallToAction />
                <Container maxW="container.xl" flex="1" py={8}>
                    <Heading size="lg" mb={4}>What's New</Heading>
                    <Text color="red.500">
                        Module "{moduleId}" does not have a What's New page available yet.
                    </Text>
                </Container>
                <FooterWithFourColumns />
            </Box>
        );
    }

    const ModuleWhatsNewComponent = moduleData.component;

    return (
        <Box minH="100vh" display="flex" flexDirection="column">
            <NavbarWithCallToAction />
            <ModuleWhatsNewComponent moduleConfig={moduleData.config} />
            <FooterWithFourColumns />
        </Box>
    );
};

export default WhatsNew;
